 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		44: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		44: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"vendors~bin-groups~bin-groups-detail~garbage-bin-creation~garbage-bin-detail~garbage-bin-map-overvie~4a363c32","1":"bin-groups-detail~cleaning-action-detail~cleaning-action-overview~experience-scan-detail~garbage-bin~e24de01d","2":"vendors~bin-groups-detail~experience-scan-creation~experience-scan-detail~garbage-bin-creation~garba~bf6742b1","3":"vendors~cleaning-action-detail~cleaning-action-overview~garbage-bin-detail~garbage-bin-measurement-o~592e30d8","4":"vendors~experience-scan-creation~garbage-bin-creation~garbage-bin-detail~garbage-bin-measurement~inc~650ecb95","5":"bin-groups~bin-groups-detail~garbage-bin-creation~garbage-bin-map-overview~incident-creation~inciden~be595771","6":"export-creation~garbage-bin-measurement-overview~incidents~monitoring-report~project-comparison~repo~23191834","7":"vendors~measurement-detail~monitoring-report~pdfs~reporting-bins~reporting-incidents~reporting-monitoring","8":"vendors~garbage-bin-map-overview~incidents~incidents-map~measurement-detail~reporting-incidents","9":"cleaning-action-overview~garbage-bin-measurement-overview~incidents~volunteer-groups-overview","10":"experience-scan-creation~volunteer-post-detail~volunteer-post-wizard","11":"incident-registration-end~incident-registration-start","12":"measuring-period~measuring-period-detail","13":"ActivityMapDetail","14":"HeatmapTest","15":"HeatmapTest2","16":"app-event-map","17":"bin-groups","18":"bin-groups-detail","19":"cleaning-action-detail","20":"cleaning-action-overview","21":"experience-scan-creation","22":"experience-scan-creation-end","23":"experience-scan-detail","24":"export-creation","25":"export-creation-end","26":"garbage-bin-creation","27":"garbage-bin-creation-end","28":"garbage-bin-detail","29":"garbage-bin-map-overview","30":"garbage-bin-measurement","31":"garbage-bin-measurement-end","32":"garbage-bin-measurement-overview","33":"garbage-bin-overview","34":"home","35":"incident","36":"incident-creation","37":"incident-duplicate","38":"incident-end","39":"incident-registration","40":"incident-registration-end","41":"incident-registration-start","42":"incidents","43":"incidents-map","45":"measurement-creation","46":"measurement-detail","47":"measuring-period","48":"measuring-period-detail","49":"monitoring","50":"monitoring-report","51":"not-found","52":"password-request","53":"password-reset","55":"pdfs","56":"project-comparison","57":"project-creation","58":"project-creation-end","59":"project-measurement-detail","60":"reporting","61":"reporting-bins","62":"reporting-incidents","63":"reporting-monitoring","64":"vendors~garbage-bin-measurement","65":"vendors~garbage-bin-overview","66":"vendors~incident","67":"vendors~measuring-period","68":"volunteer-groups-detail","69":"volunteer-groups-overview","70":"volunteer-map","71":"volunteer-post-detail","72":"volunteer-post-wizard"}[chunkId]||chunkId) + "." + "78ccf0d8745edd516dbc" + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"10":1,"13":1,"14":1,"15":1,"16":1,"17":1,"18":1,"21":1,"23":1,"24":1,"26":1,"28":1,"30":1,"33":1,"35":1,"36":1,"39":1,"45":1,"47":1,"49":1,"57":1,"67":1,"68":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "../css/" + ({"0":"vendors~bin-groups~bin-groups-detail~garbage-bin-creation~garbage-bin-detail~garbage-bin-map-overvie~4a363c32","1":"bin-groups-detail~cleaning-action-detail~cleaning-action-overview~experience-scan-detail~garbage-bin~e24de01d","2":"vendors~bin-groups-detail~experience-scan-creation~experience-scan-detail~garbage-bin-creation~garba~bf6742b1","3":"vendors~cleaning-action-detail~cleaning-action-overview~garbage-bin-detail~garbage-bin-measurement-o~592e30d8","4":"vendors~experience-scan-creation~garbage-bin-creation~garbage-bin-detail~garbage-bin-measurement~inc~650ecb95","5":"bin-groups~bin-groups-detail~garbage-bin-creation~garbage-bin-map-overview~incident-creation~inciden~be595771","6":"export-creation~garbage-bin-measurement-overview~incidents~monitoring-report~project-comparison~repo~23191834","7":"vendors~measurement-detail~monitoring-report~pdfs~reporting-bins~reporting-incidents~reporting-monitoring","8":"vendors~garbage-bin-map-overview~incidents~incidents-map~measurement-detail~reporting-incidents","9":"cleaning-action-overview~garbage-bin-measurement-overview~incidents~volunteer-groups-overview","10":"experience-scan-creation~volunteer-post-detail~volunteer-post-wizard","11":"incident-registration-end~incident-registration-start","12":"measuring-period~measuring-period-detail","13":"ActivityMapDetail","14":"HeatmapTest","15":"HeatmapTest2","16":"app-event-map","17":"bin-groups","18":"bin-groups-detail","19":"cleaning-action-detail","20":"cleaning-action-overview","21":"experience-scan-creation","22":"experience-scan-creation-end","23":"experience-scan-detail","24":"export-creation","25":"export-creation-end","26":"garbage-bin-creation","27":"garbage-bin-creation-end","28":"garbage-bin-detail","29":"garbage-bin-map-overview","30":"garbage-bin-measurement","31":"garbage-bin-measurement-end","32":"garbage-bin-measurement-overview","33":"garbage-bin-overview","34":"home","35":"incident","36":"incident-creation","37":"incident-duplicate","38":"incident-end","39":"incident-registration","40":"incident-registration-end","41":"incident-registration-start","42":"incidents","43":"incidents-map","45":"measurement-creation","46":"measurement-detail","47":"measuring-period","48":"measuring-period-detail","49":"monitoring","50":"monitoring-report","51":"not-found","52":"password-request","53":"password-reset","55":"pdfs","56":"project-comparison","57":"project-creation","58":"project-creation-end","59":"project-measurement-detail","60":"reporting","61":"reporting-bins","62":"reporting-incidents","63":"reporting-monitoring","64":"vendors~garbage-bin-measurement","65":"vendors~garbage-bin-overview","66":"vendors~incident","67":"vendors~measuring-period","68":"volunteer-groups-detail","69":"volunteer-groups-overview","70":"volunteer-map","71":"volunteer-post-detail","72":"volunteer-post-wizard"}[chunkId]||chunkId) + "." + "78ccf0d8745edd516dbc" + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				function loadScript(src, retries) {
 				  var script = document.createElement('script');
 				  var retryAttempt = 1 - retries + 1;
 				  var retryAttemptString = '&retry-attempt=' + retryAttempt;
 				  var onScriptComplete;

 				  script.charset = 'utf-8';
 				  script.timeout = 120;
 				  if (__webpack_require__.nc) {
 				    script.setAttribute('nonce', __webpack_require__.nc);
 				  }
 				  script.src = src;

 				  onScriptComplete = function(event) {
 				    // avoid mem leaks in IE.
 				    script.onerror = script.onload = null;
 				    clearTimeout(timeout);
 				    var chunk = installedChunks[chunkId];
 				    if (chunk !== 0) {
 				      if (chunk) {
 				        if (retries === 0) {
 				          var errorType =
 				            event && (event.type === 'load' ? 'missing' : event.type);
 				          var realSrc = event && event.target && event.target.src;
 				          error.message =
 				            'Loading chunk ' +
 				            chunkId +
 				            ' failed after 1 retries.\n(' +
 				            errorType +
 				            ': ' +
 				            realSrc +
 				            ')';
 				          error.name = 'ChunkLoadError';
 				          error.type = errorType;
 				          error.request = realSrc;
 				          location.reload(true);
 				          chunk[1](error);
 				          installedChunks[chunkId] = undefined;
 				        } else {
 				          var cacheBust = 'cache-bust=true' + retryAttemptString;
 				          var retryScript = loadScript(
 				            jsonpScriptSrc(chunkId) + '?' + cacheBust,
 				            retries - 1
 				          );
 				          document.head.appendChild(retryScript);
 				        }
 				      } else {
 				        installedChunks[chunkId] = undefined;
 				      }
 				    }
 				  };
 				  var timeout = setTimeout(function() {
 				    onScriptComplete({ type: 'timeout', target: script });
 				  }, 120000);
 				  script.onerror = script.onload = onScriptComplete;
 				  return script;
 				}

 				var script = loadScript(jsonpScriptSrc(chunkId), 1);
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/js/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 689);
